/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IMilFormEmbedData } from './mil-form-embed.data';
import { IMilFormEmbedProps } from './mil-form-embed.props.autogenerated';
import { isNonceEnabled } from '@msdyn365-commerce/core-internal';
import MsDyn365 from '@msdyn365-commerce/core';

export interface IMilFormEmbedViewProps extends IMilFormEmbedProps<IMilFormEmbedData> {
    script: Node;
}

/**
 *
 * MilFormEmbed component
 * @extends {React.PureComponent<IMilFormEmbedProps<IMilFormEmbedData>>}
 */
class MilFormEmbed extends React.PureComponent<IMilFormEmbedProps<IMilFormEmbedData>> {
    public render(): JSX.Element | null {
        if (!MsDyn365.isBrowser) {
            return null;
        }
        const source = this.props.config.inlineScript;
        const nonceToken = this.props.context && isNonceEnabled(this.props.context.request);
        const script = document.createElement('script');
        script.innerText = source;
        if (nonceToken) {
            script.setAttribute('nonce', nonceToken);
        }
        const viewProps: IMilFormEmbedViewProps = {
            ...this.props,
            script
        };
        return MsDyn365.isBrowser ? this.props.renderView(viewProps) : null;
    }
}

export default MilFormEmbed;
